'use client';
import { Result, Spin } from '@bfe/moly';
import clsx from 'clsx';
import { isNil } from 'lodash-es';
import { ReactNode } from 'react';

export type AsyncStateRenderProps<T = unknown> = {
  loading: boolean;
  data?: T;
  error?: unknown;
  onLoading?: (dom: ReactNode) => ReactNode;
  onError?: (dom: ReactNode) => ReactNode;
  children: (data: NonNullable<T>) => ReactNode;
  errorSize?: 'medium' | 'small' | 'large';
  loadingClassName?: string;
  errorClassName?: string;
  className?: string;
};

export function AsyncStateRender<T = unknown>({
  loading,
  data,
  error,
  onError,
  onLoading,
  errorSize = 'small',
  children,
  className,
  loadingClassName,
  errorClassName,
}: AsyncStateRenderProps<T>) {
  if (loading) {
    const dom = (
      <div
        className={clsx(
          'flex h-full w-full items-center justify-center',
          loadingClassName,
          className
        )}
      >
        <Spin />
      </div>
    );
    return onLoading ? onLoading(dom) : dom;
  }
  if (!isNil(error)) {
    const dom = (
      <Result
        status="error"
        size={errorSize}
        className={clsx(className, errorClassName)}
        subTitle={
          ['object', 'function'].includes(typeof error)
            ? (error as any).message || 'unknown error'
            : error
        }
      />
    );
    return onError ? onError(dom) : dom;
  }
  // @ts-ignore
  return children(data);
}
